import {
  GET_SOFTSKILLS_ABILITIES,
  GET_SOFTSKILLS_ABILITIES_SUCCESS,
  GET_SOFTSKILLS_ABILITIES_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  abilities: [],
}

const SoftskillsAbilitiesList = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOFTSKILLS_ABILITIES:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SOFTSKILLS_ABILITIES_SUCCESS:
      state = {
        ...state,
        abilities: action.payload.abilities,
        loading: false,
        done: true,
      }
      break
    case GET_SOFTSKILLS_ABILITIES_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsAbilitiesList
